import type { useUser } from '@clerk/nextjs';
import { getLegacyName } from '~/libs/auth0/legacyName';

export type ClerkUser = NonNullable<ReturnType<typeof useUser>['user']>;

const primaryEmail = (user: ClerkUser) =>
  user.primaryEmailAddress?.emailAddress ?? user.emailAddresses[0]?.emailAddress;

const firstName = (user: ClerkUser) => getLegacyName(user) ?? user.firstName;

export const getUserInitial = (user: ClerkUser) =>
  (firstName(user)?.[0] ?? primaryEmail(user)?.[0] ?? '?').toUpperCase();

/** Short form for the trigger's accessible name, where the email is a usable last resort. */
export const getUserShortName = (user: ClerkUser) => firstName(user) ?? primaryEmail(user) ?? '';

/** Full form for the panel's profile block, which is the only place the surname is shown. */
export const getUserDisplayName = (user: ClerkUser) => getLegacyName(user) ?? user.fullName ?? getUserShortName(user);
